import { useState } from "react";
import Dropdown from "../../../components/Menus&Dropdowns/Dropdown";
import PageHeader from "../../../components/Page/PageHeader";
import useMessage from "../../../hooks/useMessage";
import SnackBar from "../../../components/Alerts/SnackBar";
import BatchPredictionModal from "../components/BatchPredictionModal";
import SingleCompoundPredictionModal from "../components/SingleCompoundPredictionModal";
import NewPageTabs from "../../../components/Tabs/NewPageTabs";
import BatchPredictions from "./BatchPredictions";
import SingleCompoundPredictions from "./SingleCompoundPredictions";

const tabs = [ 'Batch Predictions', 'Single Compound Predictions' ];

export default function Resultsets() {
    const [ selectedIndex, setSelectedIndex ] = useState(0);

    const {
        open,
        setOpen,
        message,
        isSuccess,
        setPopupMessage,
    } = useMessage();


    const handleTabChange = (event: React.SyntheticEvent, index: number) => {
        setSelectedIndex(index);
    }
    

    return (
        <div className="p-10 h-screen overflow-hidden flex flex-col justify-start items-stretch gap-4">

            <PageHeader label='Resultsets'>
                <Dropdown 
                    btn={{
                        type: 'primary',
                        styling: 'solid',
                        id: 'run-prediction-button',
                        label: 'Run Prediction',
                    }}
                    options={[
                        {
                            label: 'Batch Prediction',
                            btnComp: (
                                <BatchPredictionModal 
                                    setPopupMessage={setPopupMessage}
                                    isPrimaryMenu
                                />
                            )
                        },
                        {
                            label: 'Single Compound',
                            btnComp: (
                                <SingleCompoundPredictionModal 
                                    setPopupMessage={setPopupMessage}
                                    location="header"
                                />
                            )
                        }
                    ]}
                />
            </PageHeader>

            <div>
                <NewPageTabs 
                    tabs={tabs.map((tab,i) => ({
                        label: tab,
                        index: i
                    }))}
                    selectedIndex={selectedIndex}
                    handleTabChange={handleTabChange}
                />
            </div>

            {tabs[selectedIndex] === 'Batch Predictions' ? (
                <BatchPredictions setPopupMessage={setPopupMessage}/>
            ) : (
                <SingleCompoundPredictions setPopupMessage={setPopupMessage}/>
            )}

            <SnackBar open={open} setOpen={setOpen} message={message} isSuccess={isSuccess}/>  

            
        </div>
    )
}